import { render, staticRenderFns } from "./SidePane.vue?vue&type=template&id=2b60a2da&scoped=true"
import script from "./SidePane.vue?vue&type=script&lang=js"
export * from "./SidePane.vue?vue&type=script&lang=js"
import style0 from "./SidePane.vue?vue&type=style&index=0&id=2b60a2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60a2da",
  null
  
)

export default component.exports